const theme = {
  gutter: 1,
  colors: {
    default: '#505050',
    brand: '#02658e',
    primary: '#75D0F4',
    secondary: '#a4e086',
    tertiary: '#fdbb63',
  },
  fontFamily: {
    roman: `'Helvetica Neue LT W01_55 Roman', sans-serif`,
  },
};

export default theme;



// WEBPACK FOOTER //
// ./src/config/theme.js